import React from 'react';

const OfferScroll = () => {
  const text = 'Free Delivery on every order! \u00A0\u00A0\ LIMITED STOCKS ONLY! \u00A0\u00A0\u00A0 ';
  const repeatedText = text.repeat(8);

  return (
    <div className="offer-marquee">
      <div className="offer-marquee-track !bg-black !py-2 uppercase !space-x-[10px]">
        <span >{repeatedText}</span>
        <span>{repeatedText}</span> {/* Duplicate for seamless loop */}
      </div>
    </div>
  );
};

export default OfferScroll;
